module.exports = __webpack_public_path__ + "public/SiteImages/verified.svg?94a483cd";